<header>
  <a routerLink="/" class="logo" (click)="close()">
    <img
      [src]="'/assets/images/logos/logo-' + layout + '.svg'"
      alt="Univacity Logo"
      i18n-alt="@@logoAlt"
  /></a>
  <a (click)="openSearchDrawer()">
    <un-icon class="search" type="search" theme="outline"></un-icon>
  </a>
  <un-icon type="close" theme="outline" (click)="close()"></un-icon>
</header>
<nz-tabset>
  @if (auth.isLoggedIn) {
  <nz-tab nzTitle="Dashboard" i18n-nzTitle="@@dashboard">
    <un-nav
      [menus]="dashboardMenu"
      layout="vertical"
      (linkClick)="close()"
    ></un-nav>
  </nz-tab>
  }
  <nz-tab nzTitle="Menu" i18n-nzTitle="@@menu">
    <un-nav [menus]="mainMenu" layout="vertical" (linkClick)="close()"></un-nav>
  </nz-tab>
</nz-tabset>

<footer>
  <div class="preferencce">
    <un-currency-nav (currencyChange)="close()"></un-currency-nav>
    <un-theme-switcher></un-theme-switcher>
  </div>

  @if (!auth.isLoggedIn) {
  <div class="buttons">
    <un-button
      [fullwidth]="true"
      [link]="[RoutePath.authLogin]"
      (btnClick)="close()"
      i18n
      >Login</un-button
    >
    <un-button
      [fullwidth]="true"
      type="primary"
      [link]="[RoutePath.authRegister]"
      (btnClick)="close()"
      i18n
      >Register</un-button
    >
  </div>
  } @if (auth.isLoggedIn) {
  <div class="buttons">
    <un-icon
      type="appstore"
      theme="fill"
      [routerLink]="[RoutePath.dashboard]"
      (click)="close()"
    ></un-icon>
    @if (auth.isLoggedIn) {
    <nz-badge
      [nzCount]="messageCount"
      [routerLink]="[RoutePath.dashboardMessages]"
      (click)="close()"
      ><un-icon type="message" theme="fill"></un-icon
    ></nz-badge>
    } @if ( auth.user?.avatar | fileUrl : { height: 64, width: 64 } | async; as
    src) {
    <img
      width="32"
      height="32"
      [ngSrc]="src"
      [routerLink]="[RoutePath.dashboardSettings, RoutePath.profile]"
      (click)="close()"
    />
    } @else {
    <un-icon
      type="user"
      theme="outline"
      [routerLink]="[RoutePath.dashboardSettings, RoutePath.profile]"
      (click)="close()"
    ></un-icon>
    }
    <un-icon type="logout" theme="outline" (click)="logout()"></un-icon>
  </div>
  }
</footer>
